import React from 'react';
import { FlowDefinition } from '../types';

interface SidebarProps {
  flows: FlowDefinition[];
  activeFlowId: string;
  onFlowSelect: (flowId: string) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ flows, activeFlowId, onFlowSelect }) => {
  const groupedFlows = flows.reduce((acc, flow) => {
    if (!acc[flow.region]) acc[flow.region] = [];
    acc[flow.region].push(flow);
    return acc;
  }, {} as Record<string, FlowDefinition[]>);

  // Group by country within each region
  const groupByCountry = (regionFlows: FlowDefinition[]) => {
    const byCountry: Record<string, FlowDefinition[]> = {};
    regionFlows.forEach(flow => {
      if (!byCountry[flow.country]) byCountry[flow.country] = [];
      byCountry[flow.country].push(flow);
    });
    return byCountry;
  };

  return (
    <div className="sidebar">
      <div className="brand">
        <h2>
          <i className="fa-solid fa-network-wired"></i> Flow Manager
        </h2>
      </div>

      {Object.entries(groupedFlows).map(([region, regionFlows]) => {
        const byCountry = groupByCountry(regionFlows);
        return (
          <div key={region} className="nav-group">
            <div className="nav-label">{region} Region</div>
            {Object.entries(byCountry).map(([country, countryFlows]) => (
              <React.Fragment key={country}>
                {countryFlows.map((flow) => (
                  <div
                    key={flow.id}
                    className={`nav-item ${flow.type === 'subflow' ? 'sub-item' : ''} ${activeFlowId === flow.id ? 'active' : ''}`}
                    onClick={() => onFlowSelect(flow.id)}
                  >
                    <i className={`fa-solid ${flow.type === 'subflow' ? 'fa-star-half-stroke' : 'fa-sitemap'}`}></i>
                    {flow.type === 'subflow' ? flow.title.split('_').pop() || 'CSAT' : country}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        );
      })}
    </div>
  );
};
